export const calendarStyles = `
  /* React Calendar Base Styles */
  .react-calendar {
    width: 100% !important;
    max-width: 100% !important;
    background: transparent !important;
    border: none !important;
    font-family: inherit !important;
  }
  
  /* Navigation */
  .react-calendar__navigation {
    display: flex !important;
    height: 40px !important;
    margin-bottom: 0.5em !important;
  }
  
  .react-calendar__navigation button {
    min-width: 40px !important;
    background: none !important;
    border: none !important;
    font-size: 16px !important;
    font-weight: bold !important;
    cursor: pointer !important;
    border-radius: 4px !important;
    transition: background-color 0.2s ease !important;
  }
  
  .react-calendar__navigation button:enabled {
    cursor: pointer !important;
  }
  
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #f3f4f6 !important;
    cursor: pointer !important;
  }
  
  .react-calendar__navigation button:disabled {
    opacity: 0.3 !important;
    cursor: not-allowed !important;
  }
  
  /* View Containers */
  .react-calendar__viewContainer {
    background: transparent !important;
    overflow: hidden !important;
  }
  
  .react-calendar__month-view,
  .react-calendar__year-view,
  .react-calendar__decade-view,
  .react-calendar__century-view {
    background: transparent !important;
    min-height: auto !important;
    overflow: hidden !important;
  }
  
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr) !important;
    gap: 2px !important;
    padding-top: 4px !important;
  }
  
  .react-calendar__month-view__weeks {
    display: flex !important;
    flex-direction: column !important;
    max-height: 200px !important;
    overflow: hidden !important;
  }
  
  /* Weekdays Header */
  .react-calendar__month-view__weekdays {
    background: transparent !important;
    padding-bottom: 8px !important;
  }
  
  .react-calendar__month-view__weekdays__weekday {
    padding: 8px !important;
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    text-align: center !important;
    color: #6b7280 !important;
  }
  
  /* Tiles (Days/Months/Years) */
  .react-calendar__tile {
    max-width: 100% !important;
    min-height: 38px !important;
    height: 38px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
    border: none !important;
    font-size: 0.875rem !important;
    position: relative !important;
    cursor: pointer !important;
    border-radius: 4px !important;
    transition: all 0.15s ease-in-out !important;
    box-sizing: border-box !important;
  }

  /* Year/Month/Decade view container - consistent grid */
  .react-calendar__year-view,
  .react-calendar__decade-view,
  .react-calendar__century-view {
    min-height: 240px !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 4px !important;
  }

  .react-calendar__year-view__months,
  .react-calendar__decade-view__years,
  .react-calendar__century-view__decades {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 23px 18px !important;
    padding: 4px !important;
    min-height: auto !important;
  }

  .react-calendar__year-view__months__month,
  .react-calendar__decade-view__years__year,
  .react-calendar__century-view__decades__decade {
    min-height: 38px !important;
    height: 38px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 0.875rem !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  
  .react-calendar__tile:enabled {
    cursor: pointer !important;
  }
  
  /* Hover States - Only for non-active tiles */
  .react-calendar__tile:enabled:hover:not(.react-calendar__tile--active):not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .react-calendar__tile:enabled:focus:not(.react-calendar__tile--active):not(.range-start-date):not(.range-end-date):not(.range-between-date) {
    // background-color: #f3f4f6 !important;
    color: #111827 !important;
  }
  
  /* Active/Selected Date - Preserve for single date pickers */
  .react-calendar__tile--active:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .react-calendar__tile--active:enabled:not(.range-start-date):not(.range-end-date):not(.range-between-date) {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
  }
  
  .react-calendar__tile--active:enabled:hover:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .react-calendar__tile--active:enabled:focus:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .react-calendar__tile--active:hover:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .react-calendar__tile--active:focus:not(.range-start-date):not(.range-end-date):not(.range-between-date) {
    background: #3b82f6 !important;
    color: white !important;
  }

  /* Range Selection Styles */
  .react-calendar__tile--range {
    background: #dbeafe !important;
    color: #1e40af !important;
  }

  .react-calendar__tile--rangeStart {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
  }

  .react-calendar__tile--rangeEnd {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
  }

  /* Custom Range Styles */
  .range-start-date {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 6px !important;
  }

  .range-start-date:hover {
    background: #2563eb !important;
    color: white !important;
  }

  .range-end-date {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 6px !important;
  }

  .range-end-date:hover {
    background: #2563eb !important;
    color: white !important;
  }

  .range-between-date {
    background: #216ba5 !important;
    color: white !important;
    border-radius: 6px !important;
    cursor: default !important;
    font-weight: 500 !important;
  }

  .range-between-date:hover {
    background: #1a5a8a !important;
    color: white !important;
    cursor: default !important;
  }

  /* Ensure range dates always have white text */
  .react-calendar__tile.range-start-date,
  .react-calendar__tile.range-end-date,
  .react-calendar__tile.range-between-date {
    color: white !important;
  }

  .react-calendar__tile.range-start-date abbr,
  .react-calendar__tile.range-end-date abbr,
  .react-calendar__tile.range-between-date abbr {
    color: white !important;
  }
  
  /* Today's Date */
  .react-calendar__tile--now {
    background-color: #dbeafe !important;
    color: #3b82f6 !important;
    font-weight: 500 !important;
  }
  
  .react-calendar__tile--now:hover {
    background-color: #bfdbfe !important;
    color: #3b82f6 !important;
  }

  /* Today's date when it's in the range - override with range colors */
  .react-calendar__tile--now.range-start-date,
  .react-calendar__tile--now.range-end-date {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
  }

  .react-calendar__tile--now.range-between-date {
    background: #216ba5 !important;
    color: white !important;
  }
  
  /* Disabled Tiles */
  .react-calendar__tile:disabled {
    background-color: transparent !important;
    cursor: not-allowed !important;
    opacity: 0.5 !important;
    color: #9ca3af !important;
  }
  
  .react-calendar__tile:disabled:hover {
    cursor: not-allowed !important;
    background-color: transparent !important;
  }

  .react-calendar__tile:disabled:active {
    cursor: not-allowed !important;
  }

  button.react-calendar__tile:disabled {
    cursor: not-allowed !important;
  }

  button.react-calendar__tile[disabled] {
    cursor: not-allowed !important;
  }
  
  /* Selected Year/Month */
  .selected-year-month {
    background-color: #05df72 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
  }
  
  .selected-year-month:hover {
    background-color: #04b862 !important;
    color: white !important;
  }
  
  /* Weekend Days */
  .react-calendar__month-view__days__day--weekend {
    color: #05df72 !important;
  }
  
  /* Neighboring Month Days */
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #9ca3af !important;
    opacity: 0.5 !important;
  }
  
  .react-calendar__month-view__days__day--neighboringMonth:hover {
    background-color: #f9fafb !important;
    color: #6b7280 !important;
  }

  /* Neighboring month dates should not show range colors */
  .react-calendar__month-view__days__day--neighboringMonth.range-start-date,
  .react-calendar__month-view__days__day--neighboringMonth.range-end-date,
  .react-calendar__month-view__days__day--neighboringMonth.range-between-date {
    background: transparent !important;
    color: #9ca3af !important;
    opacity: 0.5 !important;
    cursor: default !important;
  }

  /* Current month dates - ensure proper visibility */
  .react-calendar__month-view__days__day:not(.react-calendar__month-view__days__day--neighboringMonth) {
    color: #111827 !important;
  }
  
  /* DARK THEME STYLES */
  .dark .react-calendar__navigation button {
    color: #f9fafb !important;
  }
  
  .dark .react-calendar__navigation button:enabled:hover,
  .dark .react-calendar__navigation button:enabled:focus {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }
  
  .dark .react-calendar__month-view__weekdays__weekday {
    color: #9ca3af !important;
  }
  
  .dark .react-calendar__tile {
    color: #f9fafb !important;
  }
  
  .dark .react-calendar__tile:enabled:hover:not(.react-calendar__tile--active):not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .dark .react-calendar__tile:enabled:focus:not(.react-calendar__tile--active):not(.range-start-date):not(.range-end-date):not(.range-between-date) {
    background-color: #343842 !important;
    color: white !important;
  }
  
  /* Dark mode - Active/Selected Date - Preserve for single date pickers */
  .dark .react-calendar__tile--active:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .dark .react-calendar__tile--active:enabled:not(.range-start-date):not(.range-end-date):not(.range-between-date) {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
  }
  
  .dark .react-calendar__tile--active:enabled:hover:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .dark .react-calendar__tile--active:enabled:focus:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .dark .react-calendar__tile--active:hover:not(.range-start-date):not(.range-end-date):not(.range-between-date),
  .dark .react-calendar__tile--active:focus:not(.range-start-date):not(.range-end-date):not(.range-between-date) {
    background: #3b82f6 !important;
    color: white !important;
  }
  
  .dark .react-calendar__year-view__months .react-calendar__tile:enabled:hover,
  .dark .react-calendar__decade-view__years .react-calendar__tile:enabled:hover,
  .dark .react-calendar__century-view__decades .react-calendar__tile:enabled:hover {
    background-color: #343842 !important;
    color: white !important;
  }
  
  .dark .react-calendar__tile--now {
    background-color: rgba(59, 130, 246, 0.2) !important;
    color: #60a5fa !important;
  }
  
  .dark .react-calendar__tile--now:hover {
    background-color: rgba(59, 130, 246, 0.3) !important;
    color: #60a5fa !important;
  }

  /* Dark mode - Today's date when it's in the range */
  .dark .react-calendar__tile--now.range-start-date,
  .dark .react-calendar__tile--now.range-end-date {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
  }

  .dark .react-calendar__tile--now.range-between-date {
    background: #216ba5 !important;
    color: white !important;
  }

  .dark .react-calendar__tile--range {
    background: rgba(59, 130, 246, 0.2) !important;
    color: #93c5fd !important;
  }

  /* Dark mode custom range styles */
  .dark .range-start-date {
    background: #3b82f6 !important;
    color: white !important;
  }

  .dark .range-start-date:hover {
    background: #2563eb !important;
    color: white !important;
  }

  .dark .range-end-date {
    background: #3b82f6 !important;
    color: white !important;
  }

  .dark .range-end-date:hover {
    background: #2563eb !important;
    color: white !important;
  }

  .dark .range-between-date {
    background: #216ba5 !important;
    color: white !important;
    cursor: default !important;
    font-weight: 500 !important;
  }

  .dark .range-between-date:hover {
    background: #1a5a8a !important;
    color: white !important;
    cursor: default !important;
  }

  /* Dark mode - Ensure range dates always have white text */
  .dark .react-calendar__tile.range-start-date,
  .dark .react-calendar__tile.range-end-date,
  .dark .react-calendar__tile.range-between-date {
    color: white !important;
  }

  .dark .react-calendar__tile.range-start-date abbr,
  .dark .react-calendar__tile.range-end-date abbr,
  .dark .react-calendar__tile.range-between-date abbr {
    color: white !important;
  }
  
  .dark .react-calendar__tile:disabled {
    color: #6b7280 !important;
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }
  
  .dark .react-calendar__tile:disabled:hover {
    cursor: not-allowed !important;
    background-color: transparent !important;
  }

  .dark .react-calendar__tile:disabled:active {
    cursor: not-allowed !important;
  }

  .dark button.react-calendar__tile:disabled {
    cursor: not-allowed !important;
  }

  .dark button.react-calendar__tile[disabled] {
    cursor: not-allowed !important;
  }
  
  .dark .react-calendar__month-view__days__day--weekend {
    color: #f87171 !important;
  }
  
  .dark .react-calendar__month-view__days__day--neighboringMonth {
    color: #6b7280 !important;
    opacity: 0.5 !important;
  }
  
  .dark .react-calendar__month-view__days__day--neighboringMonth:hover {
    background-color: rgba(255, 255, 255, 0.05) !important;
    color: #6b7280 !important;
  }

  /* Dark mode - Neighboring month dates should not show range colors */
  .dark .react-calendar__month-view__days__day--neighboringMonth.range-start-date,
  .dark .react-calendar__month-view__days__day--neighboringMonth.range-end-date,
  .dark .react-calendar__month-view__days__day--neighboringMonth.range-between-date {
    background: transparent !important;
    color: #6b7280 !important;
    opacity: 0.5 !important;
    cursor: default !important;
  }

  /* Dark mode - Current month dates - ensure proper visibility */
  .dark .react-calendar__month-view__days__day:not(.react-calendar__month-view__days__day--neighboringMonth) {
    color: #f9fafb !important;
  }
  
  /* Responsive Adjustments */
  @media (max-width: 640px) {
    .react-calendar {
      font-size: 0.875rem !important;
    }
    
    .react-calendar__tile {
      padding: 0.375rem !important;
      font-size: 0.75rem !important;
    }
    
    .react-calendar__month-view__weekdays__weekday {
      padding: 0.375rem !important;
      font-size: 0.625rem !important;
    }
    
    .react-calendar__navigation button {
      min-width: 36px !important;
      font-size: 14px !important;
    }
  }
  
  /* Focus Styles */
  .react-calendar__tile:focus {
    outline: 2px solid #10b981 !important;
    outline-offset: 2px !important;
  }
  
  .dark .react-calendar__tile:focus {
    outline-color: #10b981 !important;
  }
`;

// Inject styles into document
if (typeof document !== "undefined") {
  const existingStyle = document.getElementById("date-range-picker-styles");
  if (!existingStyle) {
    const styleTag = document.createElement("style");
    styleTag.id = "date-range-picker-styles";
    styleTag.innerHTML = calendarStyles;
    document.head.appendChild(styleTag);
  }
}
